export const formatInterviewData = (answers, questions) => {
    return {
      interview: answers.map((qa, index) => ({
        [`question_${index + 1}`]: {
          question: qa.question,
          answer: qa.answer,
          audioUrl: qa.audioUrl
        },
      })),
    };
  };
  